import React, { memo } from 'react';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import StepHeader from './components/StepHeader';
import { Header, UtilityNavigation } from './components/CommonHeader';
import Router from './routes';
import { Loader } from './infrastructure/loader';
import { getHeaderAttribute, getCurrentStep, showHeaderUtility } from './utils/headerUtil';
import { content } from './infrastructure/content/selectors';
import NeedHelpSidePanel from './routes/ResumePortal/component/NeedHelpSidePanel';
import { resumeType, getProductName } from './infrastructure/config/selectors';
import { redirectToPreviousRoute } from './store/dataCapture/actions';
import { dataCaptureSelectors } from './store/dataCapture';
import { showNeedHelpSidePanel } from './utils';
import { ROUTE_INFO_SECTION } from './utils/constants';

const App = memo(function App({
  location,
  externalContent,
  resumeType,
  productName,
  showLoadingScreen
}) {
  const { pathname } = location;
  const { isBackNavigationNeeded } = getHeaderAttribute(pathname, externalContent, productName);

  const currentStep = getCurrentStep(pathname),
    showUtilityNavigation = showHeaderUtility(pathname);

  const dispatch = useDispatch();
  const backClick = () => {
    dispatch(redirectToPreviousRoute(pathname));
  };

  //hide header only Important info screen when loaading screen active
  const showLoading = showLoadingScreen && pathname === ROUTE_INFO_SECTION;

  return (
    <ApplicationFormShell
      header={!showLoading && <Header externalContent={externalContent} />}
      utilityNavigation={
        !showLoading &&
        showUtilityNavigation && (
          <UtilityNavigation
            backClick={backClick}
            isBackNavigationNeeded={isBackNavigationNeeded}
          />
        )
      }
      leftSidebar={currentStep && <StepHeader currentStep={currentStep} />}
      rightSidebar={showNeedHelpSidePanel(pathname, resumeType) && <NeedHelpSidePanel />}
    >
      <Loader />
      <div id="rootEl">
        <Router />
      </div>
    </ApplicationFormShell>
  );
});

const ComposedApp = compose(
  connect(state => ({
    location: state.router.location,
    externalContent: content(state),
    productName: getProductName(state),
    resumeType: resumeType(state),
    showLoadingScreen: dataCaptureSelectors.displayLoadingScreen(state)
  }))
)(App);

export { ComposedApp as App };
